import { render } from "./Add.vue?vue&type=template&id=bb08263e"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/TasksStatusesTypes/Add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb08263e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb08263e', __exports__)) {
    api.reload('bb08263e', __exports__)
  }
  
  module.hot.accept("./Add.vue?vue&type=template&id=bb08263e", () => {
    api.rerender('bb08263e', render)
  })

}


export default __exports__